export class EmbeddedTweet{
  url: string;
  html: string;
}
